<template>
    <div class="form-floating family-select">
        <vue-tags-input
            class="form-control"
            v-model="selected"
            :tags="options"
            :autocomplete-items="autocompleteItems"
            :add-only-from-autocomplete="true"
            @tags-changed="update"
            :placeholder="trans('general.page.children.add_family_member')"
        />
        <input type="hidden" name="parents" :value="JSON.stringify(options.map(val => val.value))">
        <label class="form-label">{{ trans('general.page.children.fields.parents') }}</label>
    </div>
</template>
<script>
import axios from "axios";
import VueTagsInput from '@johmun/vue-tags-input';

export default {
    name: "FamilySelect",
    props: {
        parents: {
            type: Array,
            required: true
        },
        showUsername: {
            type: Boolean,
            required: false,
            default: false
        },
        autoLoad: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    components: {
        VueTagsInput
    },

    data() {
        return {
            options: [],
            selected: '',
            autocompleteItems: [],
            debounce: null,
        }
    },
    watch: {
        'selected': 'load',
        parents: function () {
            this.update(this.getMappedParents(), false);
        }
    },
    methods: {
        update(newTags, emitChanges = true) {
            this.autocompleteItems = [];
            this.options = newTags;

            this.$emit('input', this.options.map(val => val.value));
            if (emitChanges) {
                this.$emit('change', this.options);
            }
        },
        load: function () {
            if (this.selected.length < 1) return;

            clearTimeout(this.debounce);
            this.debounce = setTimeout(() => {
                axios.get(`/parents?search=${this.selected}&limit=6`).then(response => {
                    this.autocompleteItems = response.data.data.data.map(a => {
                        return {text: a.name + ' ' + a.surname, value: a.id};
                    });
                });
            }, 600);
        },
        getMappedParents() {
            return this.parents.map(a => {
                let username = a.text ?? (a.name + ' ' + a.surname);
                if (this.showUsername && a.username) {
                    username += ' (' + a.username + ')';
                }
                return {text: username, value: a.value ?? a.id};
            });
        }
    },
    mounted() {
        if (this.autoLoad) {
            this.load();
            this.update(this.getMappedParents());
        }
    }
}
</script>
